module.exports = __webpack_public_path__ + "img/web_video_poster.082ed388.jpg";